import React, { useState, useEffect } from 'react';

import { parseDate } from '../utils/parseDate';
import { getStepFromStatus, getStatusText, isValidEmail } from '../utils/Miscellaneous';
import usePostNotificationsAlerts from '../hooks/usePostNotificationsAlerts';
import '../styles/logging.css';

const CreateJiraComponent = ({ transactions = [] }) => { // Default transactions to an empty array
    const [jiraTicketSubject, setjiraTicketSubject] = useState('');
    const [emailAddress, setEmailAddress] = useState('');
    const [error, setError] = useState('');
    const [showResponse, setShowResponse] = useState(false);
    const [responseText, setResponseText] = useState('');
    const { postNotificationsAlerts, alertResponse, postError } = usePostNotificationsAlerts("JIRA", {});

    const handleUserDetailChange = (e) => {
        setjiraTicketSubject(e.target.value);
    };

    const handleEmailChange = (e) => {
        setEmailAddress(e.target.value);
    };

    const handleSubmit = async () => {
        setError('');

        if (!jiraTicketSubject) {
            setError('Jira ticket subject cannot be empty');
            return;
        }

        if (!isValidEmail(emailAddress)) {
            setError('Please enter a valid email address');
            return;
        }

        console.log("transactions ---",transactions);
        
        if (!Array.isArray(transactions) || transactions.length === 0) { // Check if transactions is an array and has items
            setError('No transactions available');
            return;
        }


        const transactionDetails = transactions.map((transaction) => (
            `${parseDate(transaction?.DateTime)} - Boomi ${getStepFromStatus(transaction?.boomiStatus)} EDI ${transaction?.documentType} ${transaction?.documentReferenceType} ${transaction?.documentIdentifier} ${getStatusText(transaction?.boomiStatus) === 'sent' ? `to ${transaction?.receiverName}` : `from ${transaction?.senderName}`} ${transaction?.boomiStatus === 'Received-Error' ? 'with errors' : ''}`
        )).join('\n');

        const JiraJsonRequest = {
            userinput: jiraTicketSubject,
            users_email_id: emailAddress,
            doctype: transactions[0]?.documentReferenceType,
            Customer: transactions[0]?.senderName,
            documentidentifier: transactions[0]?.documentIdentifier,
            MessagegroupID: transactions[0]?.messageGroupId,
            transactiondetails: transactionDetails
        };

        console.log('JiraJsonRequest:', JiraJsonRequest);

        if (window.confirm('Are you sure you want to create a Jira ticket?')) {
            try {
                await postNotificationsAlerts(JiraJsonRequest);
                setShowResponse(true);
            } catch (error) {
                console.error('Error posting notification alert:', error);
                setError('Failed to create Jira ticket');
            }
        }
    };

    const responseMessage = (response) => {
        const baseMessage = response?.message || '';
        const ticketDetails = response?.additionalDetails ? `Ticket number: ${response.additionalDetails}` : '';
        return `${baseMessage}\n${ticketDetails}`.trim();
    };

    useEffect(() => {
        if (alertResponse) {
            setResponseText(responseMessage(alertResponse));
        }
    }, [alertResponse]);

    const copyToClipboard = () => {
        navigator.clipboard.writeText(responseText);
        setShowResponse(false);
    };

    return (
        <div className='transaction-logs'>
            <input
                name='jiraTicketSubject'
                value={jiraTicketSubject}
                onChange={handleUserDetailChange}
                placeholder="Enter Jira ticket subject"
            />
            <input
                name='emailAddress'
                value={emailAddress}
                onChange={handleEmailChange}
                placeholder='Email address'
            />
            <button onClick={handleSubmit} className='jira-button'>Create Jira Ticket</button>
            {error && <p className="error-message">{error}</p>}
            {postError && <p className="error-message">Error: {postError}</p>}
            {alertResponse && showResponse && (
                <div className="response-container">
                    <textarea className="response-text" readOnly value={responseText} />
                    <button onClick={copyToClipboard} className='copy-button'>Copy to Clipboard</button>
                    <button onClick={() => setShowResponse(false)} className='close-button'>Close</button>
                </div>
            )}
        </div>
    );
};

export default CreateJiraComponent;
